import store from '../../../helpers/store';
import Logger from '../../../../common/logger';
import Tracker from '../../../genesys/tracker';
import * as Conditions from './conditions';
import * as QuestionnaireActions from '../../views/questionnaire/actions';

const ROUTING_TABLE = {
    CHAT: 'CHATSAVE',
    CHATSAVE: 'QUESTIONNAIRE'
};

const ROUTING_MODE = {
    SWITCHING: 'SWITCHING',
    CLOSING: 'CLOSING'
};

const PRELOADERS = {
    preloader: () => {
        return true;
    },

    click2call: () => {
        return true;
    },

    visualivr: () => {
        return true;
    },

    contact: (state) => {
        const feature = Conditions.isContactAvailable(state);
        if (feature.available) {
            return true;
        } else {
            if (feature.level === 'error') {
                Logger.error(feature.reason);
            } else {
                Logger.log(feature.reason);
            }
            return false;
        }
    },

    cmb: (state) => {
        const feature = Conditions.isCMBAvailable(state);
        if (feature.available) {
            Tracker.acceptCallbackInvite();
            return true;
        } else {
            if (feature.level === 'error') {
                Logger.error(feature.reason);
            } else {
                Logger.log(feature.reason);
            }
            return false;
        }
    },

    chat: (state) => {
        const feature = Conditions.isChatAvailable(state);
        if (feature.available) {
            return true;
        } else {
            if (feature.level === 'error') {
                Logger.error(feature.reason);
            } else {
                Logger.log(feature.reason);
            }
            return false;
        }
    },

    chatsave: (state) => {
        const feature = Conditions.isChatSaveAvailable(state);
        if (feature.available) {
            return true;
        } else {
            if (feature.level === 'error') {
                Logger.error(feature.reason);
            } else {
                Logger.log(feature.reason);
            }
            return false;
        }
    },

    questionnaire: () => {
        return QuestionnaireActions.areConditionsMet('router');
    }
};

const checkView = (state, view, mode) => {
    if (!view) {
        Tracker.cancelInvite();
        return null;
    }

    const viewLowCase = view.toLowerCase();
    let newView = '';
    Logger.log(`Router.checkView [view=${view}, mode=${mode}]`);

    if (mode === ROUTING_MODE.SWITCHING) {
        if (PRELOADERS[viewLowCase] && PRELOADERS[viewLowCase](state)) {
            Logger.log('Router.checkView: ' + view);
            newView = view;
        } else {
            newView = checkView(state, ROUTING_TABLE[view], ROUTING_MODE.SWITCHING);
        }
    } else if (mode === ROUTING_MODE.CLOSING) {
        newView = checkView(state, ROUTING_TABLE[view], ROUTING_MODE.SWITCHING);
    }

    return newView;
};

export const route = (currentView) => {
    const state = store.getState();

    if (currentView != null && currentView !== state.widget.currentView) {
        return checkView(state, currentView, ROUTING_MODE.SWITCHING);
    } else {
        return checkView(state, state.widget.currentView, ROUTING_MODE.CLOSING);
    }
};
